
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcRateOfTurn as ObcRateOfTurnElement} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/rate-of-turn/rate-of-turn.js';
 
 
 

 
 export const ObcRateOfTurn = createComponent({
   react: React,
   tagName: 'obc-rate-of-turn',
   elementClass: ObcRateOfTurnElement,
   events: {
     
   }
  });
 
 